/**
 * O DEPÓSITO dos `resultados` da simulação criada pela conversa (spec-007).
 *
 * Slice próprio, composto em `ia.js`, porque o depósito tem UM dono — o
 * captador de `tool_result` em `api/apiFeeFixoIa.js` — e o cartão só lê daqui
 * se o preview corrente já está no servidor (ou por que não está). Guardar a
 * marca na instância do cartão repetia o POST a cada remount (F5 com histórico,
 * troca de aba que destrói o drawer) e pintava erro sobre cartão histórico.
 *
 * Um registro só, do ÚLTIMO depósito: `previewId` diz de qual preview ele fala,
 * então trocar a pendência não exige reset — os getters comparam com a corrente.
 */

const SEM_DEPOSITO = () => ({ previewId: '', ok: false, erro: '' })

export const criarStateDeposito = () => ({
  depositoDaSimulacao: SEM_DEPOSITO(),
})

const previewCorrente = (state) =>
  state.simulacaoPendente && state.simulacaoPendente.previewId
    ? state.simulacaoPendente.previewId
    : ''

const erroDoPreview = (state, previewId) => {
  const deposito = state.depositoDaSimulacao
  return previewId && deposito.previewId === previewId ? deposito.erro : ''
}

export const depositoGetters = {
  /** O `previewId` que JÁ está no servidor — vazio até o primeiro sucesso. */
  previewIdDepositado: (state) =>
    state.depositoDaSimulacao.ok ? state.depositoDaSimulacao.previewId : '',
  /** O erro do depósito, só se for do preview CORRENTE — histórico não herda. */
  erroDoDeposito: (state) => erroDoPreview(state, previewCorrente(state)),
  /**
   * O erro de UM preview, pelo id — para o chat imersivo, que deposita sem
   * escrever a pendência e por isso não pode ler pelo "corrente".
   */
  erroDoDepositoDoPreview: (state) => (previewId) => erroDoPreview(state, previewId),
}

export const depositoMutations = {
  SET_DEPOSITO_DA_SIMULACAO: (state, payload) => {
    state.depositoDaSimulacao = { ...SEM_DEPOSITO(), ...(payload || {}) }
  },
}

export const depositoActions = {
  setDepositoDaSimulacao: (context, payload) =>
    context.commit('SET_DEPOSITO_DA_SIMULACAO', payload),
}
